/**
 * Whether an admin has server updates to plan or to install, after the skip of this browser.
 * Always false for a viewer.
 */

import { useAtomValueRawSync } from 'jotai';

import { needsAttention } from '@/lib/updatesViewUtils';
import { adminAvailableUpdatesAtom } from '@/state/api/updatesAtoms';
import { skippedVersionAtom } from '@/state/ui/skippedVersionAtoms';

export function useDoUpdatesNeedAttention(): boolean {
    const availableUpdates = useAtomValueRawSync(adminAvailableUpdatesAtom);
    const skippedText = useAtomValueRawSync(skippedVersionAtom);
    return needsAttention(availableUpdates, skippedText);
}
